var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "email-receipt-container" }, [
    _vm.receiptType === "email"
      ? _c("div", [
          _c("div", { staticClass: "has-text-centered" }, [
            _c("div", { staticClass: "columns is-centered" }, [
              _c(
                "div",
                { staticClass: "column is-6" },
                [
                  !_vm.emailSent && !_vm.receiptLoader
                    ? [
                        _c("p", { staticClass: "is-size-5" }, [
                          _vm._v(
                            " Please enter an email and we'll send you a copy of your receipt"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field" }, [
                          _c(
                            "div",
                            { staticClass: " has-text-centered" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.email,
                                    expression: "email"
                                  }
                                ],
                                staticClass:
                                  "input is-hovered email-input text-input",
                                attrs: {
                                  autofocus: "",
                                  type: "email",
                                  placeholder: "yo@aol.com"
                                },
                                domProps: { value: _vm.email },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.email = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("BaseButton", {
                                attrs: {
                                  title: "Send Receipt",
                                  classNames: ["button--modifier", "send-btn"]
                                },
                                on: { click: _vm.sendReceipt }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.receiptLoader
                    ? _c("BaseLoader", { attrs: { type: "menu" } })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.emailSent
                    ? [
                        _c("p", { staticClass: "is-size-5" }, [
                          _vm._v(
                            "A copy of your receipt has successfully been sent to " +
                              _vm._s(_vm.email)
                          )
                        ])
                      ]
                    : _vm._e()
                ],
                2
              )
            ])
          ]),
          _vm._v("\n        " + _vm._s(_vm.msg) + "\n    ")
        ])
      : _vm.receiptType === "SMS"
        ? _c("div", { staticClass: "has-text-centered" }, [
            _c("p", { staticClass: "is-size-1" }, [_vm._v("😊")]),
            _vm._v(" "),
            _c("p", { staticClass: "is-size-5" }, [_vm._v(_vm._s(_vm.msg))])
          ])
        : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f31c2e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f31c2e5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/EmailReceipt.vue
// module id = null
// module chunks = 